import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

import { MIN_TAP_TARGET } from './CustomersReviewsDrawer.styles';

/** Narrower than a 44px tap target on purpose: nine controls must share a 375px row. */
const PAGE_WIDTH = '32px';

export const list = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(${themeVariables.spacing.xxs});
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const pageButton = css`
  min-width: ${PAGE_WIDTH};
  min-height: ${MIN_TAP_TARGET};
  padding: 0;
  border: 0;
  background: none;
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: var(${themeVariables.typography.body.sizes.md.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.md.lineHeight});
  letter-spacing: var(${themeVariables.typography.body.letterSpacing});
  color: var(${themeVariables.colors.content.tertiary});
  cursor: pointer;

  &[data-is-active='true'] {
    color: var(${themeVariables.colors.content.interactive});
  }

  &:disabled {
    color: var(${themeVariables.colors.content.disabled});
    cursor: not-allowed;
  }
`;

export const ellipsis = css`
  padding: 0;
  color: var(${themeVariables.colors.content.tertiary});
`;
